import useCustomModal, {UseCustomModalProps} from "./useCustomModal";
import {IPopulatedJob} from "../../types/FrontendTypes.ts";
import {Box, Typography} from "@mui/material";
import JobRest from "../../rest/JobRest.ts";
import React from "react";
import ImageRest from "../../rest/ImageRest.ts";
import {ModalJobCard} from "./ModalCards/ModalJobCard.tsx";
import {ModalCutterCard} from "./ModalCards/ModalCutterCard.tsx";
import {Dangerous, RestartAlt} from "@mui/icons-material";

export interface ResetJobModalProps {
    job?: IPopulatedJob;
    jobRest: JobRest;
    imageRest: ImageRest;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    afterReset?: (newJob: any) => void;
}

export const useResetJobModal = (props: ResetJobModalProps) => {
    const {job, jobRest, imageRest, afterReset} = props;
    let modalOptions: UseCustomModalProps;

    if (job && job.cutter && job.cutter.state.jobId === job._id) {
        const content =
            <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
                <Typography>The job you are trying to reset</Typography>
                <ModalJobCard job={job} imageRest={imageRest}/>
                <Typography>is currently being executed on this cutter:</Typography>
                <ModalCutterCard cutter={job.cutter} imageRest={imageRest}/>
                <Typography>Do you want to abort the job execution?</Typography>
            </Box>

        modalOptions = {
            title: "Abort running job?",
            customContent: content,
            defaultAction: {
                label: "Reset & Abort",
                method: () => jobRest.reset(job._id, true).then(afterReset),
                icon: <Dangerous/>,
                color: "error"
            },
            secondaryAction: {
                label: "Reset & Keep running",
                method: () => jobRest.reset(job._id, false).then(afterReset),
                icon: <RestartAlt/>,
                color: "error"
            },
            cancelAction: {
                label: "Cancel",
                props: {sx: {mr: 2}}
            },
        };
    } else if (job) {
        const content =
            <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
                <Typography>Are you sure, that you want to reset this job?</Typography>
                <ModalJobCard job={job} imageRest={imageRest}/>
            </Box>

        modalOptions = {
            title: "Confirm job reset",
            customContent: content,
            defaultAction: {
                label: "Reset",
                method: () => jobRest.reset(job._id).then(afterReset),
                icon: <RestartAlt/>,
                color: "error"
            },
            cancelAction: {
                label: "Cancel",
            },
        };
    } else {
        modalOptions = {
            title: "Error",
            contentText: "The job data is not available. Please try again later.",
            defaultAction: {
                label: "Close",
                method: () => {
                },
            },
            cancelAction: {
                label: "Cancel",
            },
        };
    }

    const {open} = useCustomModal(modalOptions);

    return open;
};

export default useResetJobModal;